import { showInvitePromoModal } from "../modal/ModalManager";

/**
 * Opens the Invite Promo. If Special Deals are also eligible, queues them after closing.
 * We rely on ModalManager's internal queue to respect order: open promo first, then special deals.
 */
export function showInvitePromo(): void {
  // Only open promo. Ordering with Special Deals is handled by caller initialization
  // which triggers SpecialDealsService after this, letting ModalManager queue it.
  showInvitePromoModal();
}
